<app-search-field [(ngModel)]="query" />

<mat-checkbox
  class="price"
  [color]="'primary'"
  [checked]="allChecked"
  [indeterminate]="isIndeterminate"
  (change)="toggle($event)"
  [labelPosition]="'after'">
  Select all ({{ count() }})
</mat-checkbox>

@if (showCheckboxForEmptyValue) {
  <mat-checkbox
    class="price"
    [color]="'primary'"
    [(ngModel)]="filter.is_null"
    (change)="updateFilterChangeTime()"
    [labelPosition]="'after'">
    Empty
  </mat-checkbox>
}

@for (checkbox of viewDictionary(); track checkbox.id) {
  <mat-checkbox
    class="price"
    [color]="'primary'"
    [checked]="selectedSet.has(checkbox.id)"
    (change)="toggleOne(checkbox.id)"
    [labelPosition]="'after'">
    {{ checkbox.name }}
  </mat-checkbox>
}
